import { call, put, select, takeLatest } from "redux-saga/effects";
import request from "../../api/request";

function* fetchPackagingList(payload) {
  try {
    yield put({
      type: "FETCH_PACKAGING_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const params = new URLSearchParams();

    Object.entries(payload?.value || {}).forEach(([key, value]) => {
      params.append(key, String(value));
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/packaging?${params.toString()}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_PACKAGING_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Error al cargar los embalajes",
      },
    });
    yield put({
      type: "FETCH_PACKAGING_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* createPackaging(payload) {
  try {
    yield put({ type: "CREATE_PACKAGING_REQUESTING" });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/packaging`;

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Éxito",
        message: response?.message || "Embalaje creado correctamente",
      },
    });

    yield put({
      type: "CREATE_PACKAGING_SUCCESS",
      value: response?.data,
    });

    const state = yield select();
    const lastParams = state.packagingState.lastFetchParams;

    yield put({
      type: "FETCH_PACKAGING_REQUEST",
      value: lastParams,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Error al crear el embalaje",
      },
    });
    yield put({
      type: "CREATE_PACKAGING_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* getPackagingById(payload) {
  try {
    yield put({
      type: "READ_PACKAGING_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/packaging/${payload.value.id}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "READ_PACKAGING_SUCCESS",
      value: response.data,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Error al cargar el embalaje",
      },
    });
    yield put({
      type: "READ_PACKAGING_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* updatePackaging(payload) {
  try {
    yield put({
      type: "UPDATE_PACKAGING_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/packaging/${payload.value.id}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Éxito",
        message: response?.message || "Embalaje actualizado correctamente",
      },
    });

    yield put({
      type: "UPDATE_PACKAGING_SUCCESS",
      value: response?.data,
    });

    const state = yield select();
    const lastParams = state.packagingState.lastFetchParams;

    yield put({
      type: "FETCH_PACKAGING_REQUEST",
      value: lastParams,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Error al actualizar el embalaje",
      },
    });
    yield put({
      type: "UPDATE_PACKAGING_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* deletePackaging(payload) {
  try {
    yield put({
      type: "DELETE_PACKAGING_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/packaging/${payload.value.id}`;

    const headers = {
      method: "DELETE",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Éxito",
        message: response?.message || "Embalaje eliminado correctamente",
      },
    });

    yield put({
      type: "DELETE_PACKAGING_SUCCESS",
      value: response?.data,
    });

    const state = yield select();
    const lastParams = state.packagingState.lastFetchParams;

    yield put({
      type: "FETCH_PACKAGING_REQUEST",
      value: lastParams,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Error al eliminar el embalaje",
      },
    });
    yield put({
      type: "DELETE_PACKAGING_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* activatePackaging(payload) {
  try {
    yield put({
      type: "ACTIVATE_PACKAGING_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/packaging/${payload.value.id}/activate`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Éxito",
        message: response?.message || "Estado actualizado correctamente",
      },
    });

    yield put({
      type: "ACTIVATE_PACKAGING_SUCCESS",
      value: response?.data,
    });

    const state = yield select();
    const lastParams = state.packagingState.lastFetchParams;

    yield put({
      type: "FETCH_PACKAGING_REQUEST",
      value: lastParams,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Error al actualizar el estado del embalaje",
      },
    });
    yield put({
      type: "ACTIVATE_PACKAGING_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

export function* watchPackaging() {
  yield takeLatest("FETCH_PACKAGING_REQUEST", fetchPackagingList);
  yield takeLatest("CREATE_PACKAGING_REQUEST", createPackaging);
  yield takeLatest("READ_PACKAGING_REQUEST", getPackagingById);
  yield takeLatest("UPDATE_PACKAGING_REQUEST", updatePackaging);
  yield takeLatest("DELETE_PACKAGING_REQUEST", deletePackaging);
  yield takeLatest("ACTIVATE_PACKAGING_REQUEST", activatePackaging);
}
